import { useGtm } from '@gtm-support/vue-gtm'
import api from '@/services/api'

export const useAnalytics = () => {
  function triggerEvent({ event, metadata, value }: { event: string, metadata?: Record<string, unknown>, value?: number }) {
    const gtm = useGtm()
    if (!gtm) return
    if (metadata && metadata['ecommerce']) {
      gtm.push({ ecommerce: null })
    }
    gtm.trackEvent({
      event: event,
      ...metadata,
      value: value,
    })
  }

  function trackEvent({ event, metadata }: { event: string, metadata?: Record<string, string | number | boolean> }) {
    api.trackEvent({
      event: event,
      metadata: metadata ?? {},
    }).catch(e => console.error(e))
  }

  function setUserId(userId: string) {
    const gtm = useGtm()
    if (!gtm) return
    if (gtm.enabled()) {
      gtm.push({ user_id: userId })
    }
  }

  function setCampaign({ campaign }: { campaign: { source: string, medium: string, name: string } }) {
    const gtm = useGtm()
    if (!gtm || !campaign) return
    gtm.push({
      campaign_source: campaign.source,
      campaign_medium: campaign.medium,
      campaign_name: campaign.name,
    })
  }

  function setUserProperty(userProperties: Record<string, string>) {
    const gtm = useGtm()
    if (!gtm) return
    if (gtm.enabled()) {
      window.dataLayer?.push({ set: 'set', user_properties: userProperties })
    }
  }

  return {
    triggerEvent: triggerEvent,
    setUserId: setUserId,
    setUserProperty: setUserProperty,
    setCampaign: setCampaign,
    trackEvent: trackEvent,
  }
}
